




































import { defineComponent } from '@nuxtjs/composition-api';
import {
  BaseButton,
  BaseDivider,
  AnnularThrobber,
  TypeBody,
} from '@bambeehr/pollen';
import useBlogs from '@/modules/InformationPages/Blog/hooks/useBlogs';
import BlogCard from '@/modules/InformationPages/Blog/components/BlogCard.vue';

export default defineComponent({
  name: 'Catalog',
  layout: 'empty',
  components: {
    BaseButton,
    BaseDivider,
    AnnularThrobber,
    BlogCard,
    TypeBody,
  },
  setup() {
    const { fetchBlogs, hasShownAllBlogs, fetchBlogCount } = useBlogs();
    fetchBlogCount();
    const { blogs, isLoading } = fetchBlogs(0, 7, false, true);

    const handleLoadMore = () => {
      fetchBlogs(blogs.value.length);
    };

    return {
      blogs,
      handleLoadMore,
      isLoading,
      hasShownAllBlogs,
    };
  },
});
